{
  "nav": {
    "dashboard": "Bàn làm việc",
    "aiChat": "Trợ lý AI",
    "invoices": "Chốt sổ & Hoá đơn",
    "bookkeeping": "Sổ thu chi",
    "clients": "Khách hàng",
    "groupClass": "LỚP HỌC",
    "groupFinance": "TÀI CHÍNH",
    "aiAssistant": "Trợ lý AI",
    "mainNav": "Điều hướng chính",
    "toggleSidebar": "Thu gọn/mở rộng menu",
    "tab": {
      "today": "Hôm nay",
      "classes": "Lớp học",
      "students": "Học viên",
      "invoices": "Hoá đơn",
      "more": "Thêm",
      "moreDescription": "Điều hướng khác và tài khoản"
    }
  },
  "install": {
    "item": "Cài ứng dụng vào màn hình chính",
    "helpTitle": "Cài LopHoc vào màn hình chính",
    "helpIntro": "Trên iPhone/iPad, Safari không cho ứng dụng tự mở lời mời cài, làm hai bước sau:",
    "helpStep1": "Bấm nút Chia sẻ (ô vuông có mũi tên) ở thanh dưới của Safari.",
    "helpStep2": "Chọn \"Thêm vào MH chính\" (Add to Home Screen), rồi bấm Thêm."
  },
  "branch": {
    "all": "Tất cả chi nhánh",
    "label": "Chi nhánh",
    "trigger": "Chọn chi nhánh",
    "unassigned": "Chưa gán chi nhánh",
    "manage": "Quản lý chi nhánh",
    "menuHint": "Chọn phạm vi chi nhánh cho toàn bộ ứng dụng.",
    "clear": "Tất cả"
  },
  "orgMenu": {
    "trigger": "Menu tổ chức",
    "role": {
      "OWNER": "CHỦ LỚP",
      "ADMIN": "QUẢN TRỊ",
      "MEMBER": "GIÁO VIÊN"
    },
    "planLine": {
      "auto": "Gói {{plan}} · đối soát tự động",
      "noBank": "Gói {{plan}} · chưa liên kết ngân hàng",
      "plain": "Gói {{plan}}"
    },
    "planFree": "Free",
    "accountGroup": "Tài khoản: {{name}}",
    "switchOrg": "Chuyển tổ chức",
    "hint": {
      "members": "kèm cấu hình lương GV"
    }
  },
  "brand": {
    "name": "LopHoc.app",
    "plan": "PRO"
  },
  "user": {
    "logout": "Đăng xuất"
  },
  "aiCredits": {
    "label": "Credit AI tháng này"
  },
  "reconcile": {
    "label": "Đối soát"
  },
  "loading": "Đang tải...",
  "saving": "Đang lưu...",
  "cancel": "Huỷ",
  "save": "Lưu",
  "delete": "Xoá",
  "edit": "Sửa",
  "back": "Quay lại",
  "next": "Tiếp theo",
  "skip": "Bỏ qua",
  "finish": "Hoàn tất",
  "create": "Tạo mới",
  "view": "Xem",
  "send": "Gửi",
  "close": "Đóng",
  "copy": "Sao chép",
  "download": "Tải xuống",
  "actions": "Hành động",
  "moreActions": "Thao tác khác",
  "confirm": "Xác nhận",
  "roles": {
    "OWNER": "Chủ sở hữu",
    "ADMIN": "Quản trị viên",
    "MEMBER": "Thành viên"
  },
  "empty": {
    "filterBody": "Thử đổi trạng thái hoặc chọn tháng khác.",
    "clearFilters": "Xoá bộ lọc",
    "searchTitle": "Không tìm thấy kết quả cho “{{query}}”",
    "searchHint": "Tìm theo tên hoặc tên ở nhà, không cần gõ dấu."
  },
  "picker": {
    "selectDate": "Chọn ngày",
    "selectMonth": "Chọn tháng",
    "clear": "Xoá",
    "prevYear": "Năm trước",
    "nextYear": "Năm sau"
  },
  "rbac": {
    "adminOnly": "Chỉ dành cho quản trị viên"
  },
  "dashboardPage": {
    "title": "Tổng quan",
    "welcome": "Chào mừng bạn quay lại. Đây là tổng quan công việc của bạn."
  },
  "help": {
    "item": "Trợ giúp & góp ý",
    "itemShort": "Trợ giúp",
    "title": "Trợ giúp & góp ý",
    "subtitle": "Lỗi, đề xuất hay câu hỏi: gửi thẳng cho đội LopHoc.",
    "kind": {
      "bug": "Báo lỗi",
      "feature": "Đề xuất",
      "question": "Câu hỏi"
    },
    "placeholder": "Chuyện gì đã xảy ra, hoặc LopHoc nên làm gì tốt hơn cho bạn?",
    "messageLabel": "Nội dung góp ý",
    "send": "Gửi",
    "sending": "Đang gửi...",
    "sent": "Đã gửi, cảm ơn bạn.",
    "tooFast": "Bạn gửi hơi nhanh, thử lại sau ít phút.",
    "error": "Chưa gửi được. Thử lại, hoặc nhắn qua Zalo bên dưới.",
    "contactTitle": "Liên hệ & hướng dẫn",
    "guide": "Hướng dẫn sử dụng",
    "invite": "Gửi câu hỏi bất cứ lúc nào."
  },
  "copyright": "© 2026 LopHoc.app. Bảo lưu mọi quyền.",
  "notFound": {
    "title": "Không tìm thấy trang",
    "body": "Đường dẫn này không tồn tại, có thể gõ nhầm, hoặc trang đã được đổi chỗ.",
    "cta": "Về trang chủ"
  },
  "routeError": {
    "title": "Có lỗi xảy ra",
    "body": "Phần mềm gặp trục trặc khi mở trang này. Thử tải lại; nếu vẫn vậy thì nhắn cho tụi mình.",
    "retry": "Tải lại"
  },
  "impersonation": {
    "viewingAs": "Đang xem như {{name}} · {{org}}",
    "readOnly": "chế độ chỉ đọc",
    "exit": "Thoát",
    "popover": {
      "title": "Phiên này không ghi được gì",
      "writes": "Xem thì bình thường. Mọi thao tác lưu, tạo, sửa, xoá đều bị máy chủ từ chối. Bấm vào sẽ hiện lỗi chứ không âm thầm bỏ qua.",
      "pages": "Vài trang phải ghi mới dựng được nội dung, rõ nhất là Cài đặt · Ngân hàng, nên mở ra sẽ báo lỗi. Đó là đúng, không phải hỏng.",
      "sessions": "Danh sách buổi học ở Bàn làm việc cũng có thể ít hơn thực tế: những tuần thầy cô chưa mở tới chưa được tạo sẵn, và việc tạo đó cũng là một thao tác ghi nên bị chặn, không báo lỗi gì cả.",
      "expiry": "Phiên tự hết sau 30 phút, không gia hạn.",
      "audit": "Thầy cô không thấy gì khác thường. Mỗi lần xem như đều được ghi vào nhật ký hệ thống."
    }
  }
}
